import { VueExtension } from '../../utils/extensions/vue';
import Toast from './toast.jsx';
import ToastFunc from './functioncall.jsx';
import './toast.scss';

VueExtension.WithInstall(Toast,ToastFunc);

export default Toast;
